import { ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../components/EmptyState';
import { FormCardSkeleton } from '../../components/FormCardSkeleton';
import { PageHeader } from '../../components/PageHeader';
import { CompanyBranding } from './CompanyBranding';
import { CompanySettingsForm } from './CompanySettingsForm';
import { useCompanySettings } from './use-company-settings';

export function CompanySettingsPage() {
  const { state, saveError, saving, save, savingLogo, uploadLogo, removeLogo } = useCompanySettings();

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  return (
    <>
      <PageHeader eyebrow="Admin" title="Company" description="The company this deployment serves: its particulars, tax registration and locale." />
      {state.status === 'error' && (
        <EmptyState
          icon={ShieldAlert}
          title="Couldn't load company settings"
          description="Something went wrong loading the company settings. Try reloading the page."
        />
      )}
      {state.status === 'loading' && <FormCardSkeleton label="Loading company settings" fields={8} />}
      {state.status === 'loaded' && (
        <>
          <CompanySettingsForm settings={state.settings} error={saveError} submitting={saving} onSave={save} />
          <CompanyBranding settings={state.settings} savingLogo={savingLogo} onUploadLogo={uploadLogo} onRemoveLogo={removeLogo} />
        </>
      )}
    </>
  );
}
